export default __webpack_public_path__ + "static/media/SolarSystem_09.2332f5d6.png";